import { getMessages } from '../../../../../../../../store/constants';

export const THEME_BACKGROUND_TEXT = getMessages().getText('board_settings.theme.background');
export const VIEW_WITHOUT_BACKGROUND_TEXT = getMessages().getText('board_settings.theme.view_without_background.text');
export const VIEW_WITHOUT_BACKGROUND_BUTTON = getMessages().getText('board_settings.theme.view_without_background.button');
